import { Menu } from '../models/menu.model';

export enum MenuItemsEnum {
	ComplianceComponent = 10,
	StatisticsComponent = 20,
}

export const menuItems = [
	new Menu(
		MenuItemsEnum.ComplianceComponent,
		`Submissions`,
		'/compliances',
		null,
		'photo_library',
		null,
		null,
		false,
		0
	),
	new Menu(
		MenuItemsEnum.StatisticsComponent,
		`Statistics`,
		'/statistics',
		null,
		'insights',
		null,
		null,
		false,
		0
	),
];
